// removed by extract-text-webpack-plugin
module.exports = {"container":"urpSpo4AIyTD5IQA6qTg1","delete":"_3uk_g6xxwKAnAIFyIAkPbz"};


//////////////////
// WEBPACK FOOTER
// ./src/App/components/fields/Roles/styles.css
// module id = 2969
// module chunks = 0